export { default } from './GiftCardPage';
